import { UserInterface } from '../interfaces/user';

export class User implements UserInterface {
  nome: string;
  cognome: string;
  email: string;
  typeUser: string;
  cell: string;
  id: number;
  userName: string;
  dataNascita: Date;
  dataRegistrazione: Date;
  gender: string;
  enabled: boolean;
  firtsLogin: boolean;
  ldap: boolean;
  apKey: string;

  constructor() {
    this.id = 0;
    this.email = null;
    this.typeUser = 'customer';
    this.nome = null;
    this.cognome = null;
    this.cell = null;
    this.userName = null;
    this.dataNascita = new Date();
    this.gender = 'i';
    this.enabled = false;
    this.firtsLogin = true;
    this.ldap = false;
    this.apKey = null;
  }
}
